import { useEffect } from "react";
import ChannelConnection from "../../js/connection/ChannelConnection";
import ClientOverlay from "./ClientOverlay";
import ReactDOM from "react-dom";
import ConnectionData from "../../js/connection/ConnectionData";

export default function SFULayoutOverlay({
    connection
}: {
    connection: ChannelConnection;
}) {
    useEffect(() => {
        function onScreenshotRequest(connectionData: ConnectionData): void {
            connection.messager
                .requestScreenshot(connectionData)
                .then((videoFrameData: VideoFrameData) => {
                    connection.events.notify("onscreenshot", {
                        connectionData,
                        videoFrameData
                    });
                })
                .catch((ex) => console.log(ex));
        }

        function onUploadClick(connectionData: ConnectionData): void {
            connection.events.notify("onscreenshot", {
                connectionData,
                videoFrameData: null
            });
        }

        function resize(datas: ConnectionData[]): void {
            for (const data of datas.filter(x => !!x.view)) {
                let el = data.view.querySelector("#overlay") as HTMLElement | null;

                if (!el) {
                    el = document.createElement("div");
                    el.id = "overlay";
                    data.view.appendChild(el);
                }

                // Overlay only — never change .fm-video position; LiveSwitch owns layout.
                el.style.cssText = [
                    'position:absolute',
                    'inset:0',
                    'z-index:2',
                    'pointer-events:none',
                    'overflow:hidden',
                ].join(';');

                if (el.parentElement?.lastElementChild !== el) {
                    el.parentElement!.appendChild(el);
                }

                ReactDOM.render(
                    <ClientOverlay
                        connection={connection}
                        connectionData={data}
                        onScreenshotClick={onScreenshotRequest}
                        onUploadClick={onUploadClick}
                    />,
                    el
                );
            }
        }

        connection.events.addListener("onvideolayout", resize);
        // Catch views that already exist if layout fired before this listener attached
        resize(Object.values(connection.sfuConnection.connections));
        const boot = window.setTimeout(() => {
            resize(Object.values(connection.sfuConnection.connections));
        }, 250);

        return () => {
            connection.events.removeListener("onvideolayout", resize);
            window.clearTimeout(boot);
        };
    }, [connection]);

    return <></>;
}
